import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {PageHeader, Message, ReviewDialog, Banner} from '../../components';
import {ErrorView} from '../../pages';

const mapStateToProps = state => {
    const {error: pageError} = state.get('asset').toJS();
    const {status: errorStatus} = state.get('error').toJS();

    return {pageError, errorStatus};
};

@connect(mapStateToProps)
class PageLayout extends Component {
    getErrorMessage = error => {
        if (error && error.errorCode) {
            return (
                <p className="error-message-container">
                    <i className="esport-icon-caution" />
                    <Message code={error.errorCode} />
                </p>
            );
        }
        return '';
    };

    getPageContent = () => {
        const {children, pageError, errorStatus} = this.props;
        if (errorStatus) {
            return <ErrorView />;
        }
        return (
            <div>
                {this.getErrorMessage(pageError)}
                {children}
            </div>
        );
    };

    render() {
        const location = this.props.location || {};
        const pathname = location.pathname || '';
        const isLearnPath = pathname.indexOf('/learn') > -1;
        return (
            <div className="page-body">
                <Banner />
                <PageHeader isLearnPath={isLearnPath} />
                {this.getPageContent()}
                <ReviewDialog />
            </div>
        );
    }
}

PageLayout.propTypes = {
    children: PropTypes.any,
    pageError: PropTypes.object,
    location: PropTypes.object,
    errorStatus: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default withRouter(PageLayout);
